import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { ProjectService } from '../../core/services/project.service';

import * as _ from 'lodash';
import { doPromiseAll } from '../../core/config/core.promise-utils';

@Component({
    selector: 'template-select',
    template: `<div *ngIf="items">
        <gf-searchable-dropdown *ngIf="items.length" [items]="items" [(selected)]="selected" (selectedChange)="selectedChange($event)"></gf-searchable-dropdown>
        <p style="margin-top: .35em; margin-bottom: 0;" *ngIf="!items.length"><i translate>There are no template projects available</i></p>
    </div>`
})
export class TemplateSelectComponent implements OnInit {

    @Input() project: any = null;
    @Output() selectTemplate: EventEmitter<any> = new EventEmitter<any>();

    protected items: any = false;
    protected selected: any = null;

    constructor(private projectService: ProjectService) {}

    ngOnInit() {
        var params = { isTemplate: true, page_size: 9999 };
        const parentProjectId = _.get(this.project, 'parentProjectId', -1);
        if (parentProjectId > -1) {
            params['inOrg'] = parentProjectId;
        }

        const publicParams = { isTemplate: true, parentProjectId: 0, isPublic: 'Y', page_size: 9999 };

        const promises = {
            userTemplates: this.projectService.fetch(params),
            publicTemplates: this.projectService.fetch(publicParams)
        };

        doPromiseAll(promises)
        .then((results) =>  {

            const all = _.uniqBy(
                _.concat(
                    _.get(results, 'publicTemplates.items', []),
                    _.get(results, 'userTemplates.items', [])
                ), 'id'
            );

            this.items = all
                .map((item: any) => {
                    item.label = item.name;
                    return item;
                })
                .sort(
                    (a, b) => a.label.localeCompare(b.label, undefined, {sensitivity: 'base'})
                );

            this.selected = _.find(this.items, (item) => {
                return item.id == this.project.templateProjectId;
            });

            // If the configured default template doesn't exist,
            // pick the first available and  notify the container
            // so that the templateId is updated there.
            if (! this.selected) {
                this.selected = _.get(this.items, '[0]'); // or null
                this.selectedChange(this.selected);
            }

        });
    }

    selectedChange(item: any = null) {
        if (this.project) {
            _.set(this.project, 'templateProjectId', _.get(item, 'id', 0));
        }
        this.selectTemplate.emit(item);
    }
}
